module.exports = pratt.PrattSharedLibs.instantsearch.routers;